/**
 * Deepgram Flux TTS voices offered for a voicePipeline=FLUX bot, ranked for
 * appointment booking. Mirrors ai-engine's FluxTtsVoice enum; Flux TTS voices
 * are English-only (`flux-<voice>-en`).
 */
export type FluxVoice = 'flux-alexis-en' | 'flux-elise-en' | 'flux-haley-en' | 'flux-paige-en' | 'flux-sienna-en';

export const DEFAULT_FLUX_VOICE: FluxVoice = 'flux-haley-en';

export interface FluxVoiceOption {
  value: FluxVoice;
  name: string;
  description: string;
}

export const FLUX_VOICE_OPTIONS: FluxVoiceOption[] = [
  { value: 'flux-alexis-en', name: 'Alexis', description: 'Clear, professional, calm, caring, empathetic' },
  { value: 'flux-elise-en', name: 'Elise', description: 'Clear, professional, calm, caring, empathetic' },
  { value: 'flux-haley-en', name: 'Haley', description: 'Clear, professional, caring, calm, empathetic' },
  { value: 'flux-paige-en', name: 'Paige', description: 'Clear, professional, calm, comfortable, caring' },
  { value: 'flux-sienna-en', name: 'Sienna', description: 'Professional, calm, warm, caring' },
];

export interface FluxVoicePreviewResult {
  voice: FluxVoice;
  text: string;
  audioBase64: string;
  mime: string;
}
